import React from 'react';
import { Switch, Redirect } from 'react-router-dom';
import { publicRouteObj, privateRouteObj, onBoardingRouteObj } from './RouterConfig';
import PrivateRoute from '../components/PrivateRoute/PrivateRoute';
import OnBoardingRoute from '../components/OnBoardingRoute/OnBoardingRoute';
import PublicRoute from '../components/PublicRoute/PublicRoute';
// import Storage from '../services/Storage';

const Routes = () => {
  // const publicRoutesObj = publicRouteObj.map(route => (
  //   <Route key={route.key} exact={route.exact} path={route.path} component={route.component} />
  // ));
  // window.scroll(0, 0);
  // let userRoleDetail = Storage.getUserDetail();


  const publicRoutesObj = publicRouteObj.map(route => (
    <PublicRoute
      key={route.key}
      exact={route.exact}
      path={route.path}
      component={route.component}
      sidenav={route.sidenav}
      header={route.header}
    />
  ));

  const privateRoutesObj = privateRouteObj.map(route => {
    return (
      <PrivateRoute
        key={route.key}
        exact={route.exact}
        path={route.path}
        component={route.component}
        sidenav={route.sidenav}
        header={route.header}
        footer={route.footer ? route.footer : false}
        isPrivateAndPublic={route.isPrivateAndPublic}
        // role={route.role}
        routePermission={route.permission}
      />
    )
  });

  const onBoardingRoutesObj = onBoardingRouteObj.map(route => (
    <OnBoardingRoute
      key={route.key}
      exact={route.exact}
      path={route.path}
      component={route.component}
      sidenav={route.sidenav}
      header={route.header}
    />
  ));


  return (
    <Switch>
      {publicRoutesObj}
      {privateRoutesObj}
      {onBoardingRoutesObj}
      {/* if user enter wrong path redirect to home page */}
      <Redirect from="*" to="/" />
    </Switch>
  );
};
export default Routes;
